import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import {
    LoginFormComponent,
    RegistrationFormComponent,
    ListHeaderComponent,
    HeaderComponent,
    UnauthorizedComponent,
    UnsubscribeComponent
} from './components';
import { AuthInterceptor } from '@app/_interceptors/auth.interceptor';
import { NgxBootstrapModule } from '@app/ngx-bootstrap/ngx-bootstrap.module';
import { SharedModule } from '@app/shared/shared.module';
import { ErrorInterceptor } from '@app/_interceptors/error.interceptor';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        FormsModule,
        RouterModule,
        SharedModule,
        NgxBootstrapModule,
        ReactiveFormsModule,
        // material
        MatCardModule,
        MatFormFieldModule,
        MatSelectModule,
        MatOptionModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatTooltipModule,
        MatGridListModule,
        MatRadioModule,
        MatButtonModule,
        MatSnackBarModule,
        MatDialogModule,
        MatMenuModule,
        MatToolbarModule,
        MatSidenavModule,
        MatBadgeModule
    ],
    exports: [UnauthorizedComponent, ListHeaderComponent, HeaderComponent],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true
        }
    ],
    declarations: [
        UnauthorizedComponent,
        HeaderComponent,
        LoginFormComponent,
        RegistrationFormComponent,
        ListHeaderComponent,
        UnsubscribeComponent
    ]
})
export class CoreModule {}
